module.exports = __webpack_public_path__ + "img/RD120.png";